import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';

interface SideBarSectionItemBase {
  label: string;
  id: UuidDTO;
}

/** Content types available in the sidebar panel */
export enum BalmSidebarType {
  GLOSSARY = 'glossary',
  INTERVENTION_RECAP = 'recap',
  RESOURCES = 'resources',
  FAQ = 'faq',
  IMPRINT = 'imprint',
  BOOKMARKS = 'bookmarks',
}

/** A named group of sidebar content items (e.g., a glossary section) */
export interface SideBarGroupedSection {
  id: UuidDTO;
  name: string;
  items: SideBarSectionItem[];
}

/** The video an entry embeds in its body, in place of HTML */
export interface SideBarSectionVideo {
  /** Media id or URL, resolved by the player */
  src: string;
  posterSrc?: string;
  posterAlt?: string;
}

/** An individual sidebar entry, holding a body of either HTML or a video, never both and never neither */
export type SideBarSectionItem =
  | SideBarSectionItemBase & {html: string; video?: never}
  | SideBarSectionItemBase & {video: SideBarSectionVideo; html?: never};

/** A menu entry in the sidebar navigation with icon and i18n label key */
export interface BalmSidebarMenuItem {
  type: BalmSidebarType,
  labelKey: string,
  icon: string,
}
